// src/defer.ts
import { defer as rrDefer } from "react-router-dom";
var defer = rrDefer;

// src/loader.ts
import {
  useLoaderData as rrUseLoaderData,
  useRouteLoaderData as rrUseRouteLoaderData
} from "react-router-dom";
var useLoaderData = rrUseLoaderData;
var useRouteLoaderData = rrUseRouteLoaderData;

// src/action.ts
import { useActionData as rrUseActionData } from "react-router-dom";
var useActionData = rrUseActionData;

// src/utils.ts
var makeLoader = (loaderFn) => {
  return loaderFn;
};
var makeAction = (actionFn) => {
  return actionFn;
};

// src/components/Await.tsx
import { Await as RRAwait } from "react-router-dom";
var Await = RRAwait;

// src/index.ts
import { redirect } from "react-router-dom";
export {
  Await,
  defer,
  makeAction,
  makeLoader,
  redirect,
  useActionData,
  useLoaderData,
  useRouteLoaderData
};
